<script>
    import {sgettext} from '../../i18n.js';
    export let row = {};

    const SEQUENCE_STATUS = {
		COMPLETED: sgettext('$$COMPLETED$$'),
		IN_PROGRESS: sgettext('$$PROGRESS_1$$'),
		NOT_STARTED: sgettext('$$NOT_STARTED_1$$'),
		NOT_APPLICABLE: sgettext('$$NA$$')
	};

</script>

{#if row.tc_sequence_status === SEQUENCE_STATUS.COMPLETED}
    <span class="badge badge-pill" style="background-color:#5CB85C; color:white; font-weight: bold;">{SEQUENCE_STATUS.COMPLETED}</span>
{:else if row.tc_sequence_status === SEQUENCE_STATUS.IN_PROGRESS}
    <span class="badge badge-pill" style="background-color:#F47B2E; color:#fff; font-weight: bold;">{SEQUENCE_STATUS.IN_PROGRESS}</span>
{:else if row.tc_sequence_status === SEQUENCE_STATUS.NOT_STARTED}
    <span class="badge badge-pill" style="background-color:#adadad; color:white; font-weight: bold;">{SEQUENCE_STATUS.NOT_STARTED}</span>
{:else if row.tc_sequence_status === SEQUENCE_STATUS.NOT_APPLICABLE}
    <span class="badge badge-pill" style="background-color:#adadad; color:white; font-weight: bold;">{SEQUENCE_STATUS.NOT_APPLICABLE}</span>
{:else}
    <span style="margin-left:20px;">-</span>
{/if}